export enum FractionNumberBetweenOptionEnum {
  Inclusive = 'Inclusive',
  LeftInclusive = 'LeftInclusive',
  RightInclusive = 'RightInclusive',
  Exclusive = 'Exclusive'
}
